var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-buttons"},_vm._l((_vm.tabs),function(tab,index){return _c(_vm.getTabComponentName(tab),{key:index,tag:"component",staticClass:"tab-button",class:{
      'tab-button--active': !tab.to && _vm.currentTab === index,
      'tab-button--disabled': tab.disabled
    },attrs:{"to":_vm.getTabTo(tab),"active-class":"tab-button--active","disabled":tab.disabled},on:{"click":function($event){return _vm.handleClickTab($event, index)}}},[_vm._v("\n    "+_vm._s(tab.label)+"\n  ")])}),1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }